import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ICellRendererAngularComp } from '@ag-grid-community/angular';
import { ICellRendererParams } from '@ag-grid-enterprise/all-modules';
import { take, takeUntil } from 'rxjs/operators';
import { ReplaySubject } from 'rxjs';
import { QualityCodeDialogComponent } from 'app/shared/quality-code-dialog/quality-code-dialog.component';
import { LinkAssetServiceService } from 'app/assets/service/link-asset-service.service';
import { TagDetail } from 'app/services/graphqlApi.service';

@Component({
  selector: 'app-linkbutton',
  templateUrl: './link-button.component.html',
  styleUrls: ['./link-button.component.scss']
})

export class LinkButtonComponent implements ICellRendererAngularComp {
  readonly destroyed = new ReplaySubject(1);
  params: ICellRendererParams;
  agRowData: any;
  isLinked = false;
  disableLinkState: boolean = false;

  constructor(readonly linkAssetServiceService: LinkAssetServiceService, readonly dialog: MatDialog) {}

  agInit(params: ICellRendererParams): void {
    this.params = params;
    // console.log('this.params: ', this.params);
    if (this.params?.data){
      this.disableLinkState = (!this.params.data.dsNodeTagId || !this.params.data.dsTagValue) ? true : false;
      this.agRowData = params.node.data;
      this.linkAssetServiceService.selectedDSTag$.pipe(takeUntil(this.destroyed)).subscribe((selectedDSTag: TagDetail) => {
        if (selectedDSTag?.dsNodeTagId && (selectedDSTag.dsNodeTagId === this.params.data.dsNodeTagId)){
          this.disableLinkState = false;
        }
      });
    }
  }

  get state(){
    return true;
  }

  refresh(params: ICellRendererParams): boolean {
    this.params = params;
    return true;
  }

  linkDatasourceNode(params) {
      if(params.context?.parentComponent?.linkAssetTags && params.value){
        const dialogRef = this.dialog.open(QualityCodeDialogComponent, { width: '40%' });
        dialogRef.afterClosed().pipe(take(1)).subscribe(reasonCode => {
          if(reasonCode){
            params.node.data.commentCode = reasonCode;
            params.context?.parentComponent.linkAssetTags(params?.node?.data);
          }
        });
      } else if (params.context?.parentComponent?.linkAssetTags){
        params.context?.parentComponent.linkAssetTags(params?.node?.data);
      }
  }

  ngOnDestroy(){
    this.destroyed.next();
    this.destroyed.complete();
  }

}
